import { Heart, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from '../components/empty-state';
import { SongGrid } from '../components/song-grid';
import { TvButton } from '../components/tv-button';
import { useCatalog } from '../hooks/use-catalog';

export function FavoritesPage() {
  const navigate = useNavigate();
  const { page, loading } = useCatalog({ favorite: true, limit: 120 });
  if (!loading && page?.items.length === 0) {
    return (
      <EmptyState
        title="收藏夹还空着"
        description="在歌曲卡片上按收藏，下一次就能更快找到它。"
        action={<TvButton tone="primary" onClick={() => navigate('/search')}><Search size={21} />去找喜欢的歌</TvButton>}
      />
    );
  }
  return (
    <div className="favorites-page">
      <header className="results-heading">
        <div><span className="eyebrow">MY FAVORITES</span><h2><Heart size={31} fill="currentColor" />一按就能开唱</h2></div>
        <strong>{page?.total ?? 0} 首</strong>
      </header>
      <SongGrid songs={page?.items ?? []} loading={loading} />
    </div>
  );
}
